const changeSkill = skillsIdx => dispatch => {
  dispatch({ type: 'SKILL_CHANGED', enter: true, skillsIdx });

  setTimeout(() => dispatch({ type: 'FADE_OUT', enter: false }), 2000);
};

export default changeSkill;
